import { useMemo } from 'react';
import { H1, H2, H3, H4, Paragraph, Span } from './Typography.styles';

interface TypographyProps {
  children: any;
  className?: string;
  onClick?: () => void;
  type: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'span';
}

export function Typography({ children, className, type }: TypographyProps) {
  const element = useMemo(() => {
    switch (type) {
      case 'h1':
        return <H1 className={className}>{children}</H1>;
      case 'h2':
        return <H2 className={className}>{children}</H2>;
      case 'h3':
        return <H3 className={className}>{children}</H3>;
      case 'h4':
        return <H4 className={className}>{children}</H4>;
      case 'p':
        return <Paragraph className={className}>{children}</Paragraph>;
      case 'span':
        return <Span className={className}>{children}</Span>;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  return element;
}
